import {
  ADD_INLINE_MESSAGE,
  ADD_SINGLE_INLINE_MESSAGE,
  REMOVE_INLINE_MESSAGE,
  CLEAR_INLINE_MESSAGES,
  ADD_GROWL_MESSAGE,
  REMOVE_GROWL_MESSAGE,
  CLEAR_GROWL_MESSAGES,
} from 'messages/constants';

export const addInlineMessage = (text, type) => ({
  type: ADD_INLINE_MESSAGE,
  payload: {
    text,
    type,
  },
});

export const addSingleInlineMessage = (text, type) => ({
  type: ADD_SINGLE_INLINE_MESSAGE,
  payload: {
    text,
    type,
  },
});

export const removeInlineMessage = (id) => ({
  type: REMOVE_INLINE_MESSAGE,
  payload: { id },
});

export const clearInlineMessages = (type) => ({
  type: CLEAR_INLINE_MESSAGES,
  payload: { type },
});

export const addGrowlMessage = (text, type, title = false) => ({
  type: ADD_GROWL_MESSAGE,
  payload: {
    title,
    text,
    type,
  },
});

export const addGrowlError = (text) => addGrowlMessage(text, 'danger', 'common.error');

export const addGrowlInfo = (text) => addGrowlMessage(text, 'info', 'common.info');

export const addGrowlSuccess = (text) => addGrowlMessage(text, 'success', 'common.success');

export const addGrowlWarning = (text) => addGrowlMessage(text, 'warn', 'common.warning');

export const removeGrowlMessage = (id) => ({
  type: REMOVE_GROWL_MESSAGE,
  payload: { id },
});

export const clearGrowlMessages = (type) => ({
  type: CLEAR_GROWL_MESSAGES,
  payload: { type },
});



// WEBPACK FOOTER //
// src/modules/messages/actions/messages_actions.js